"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.recycleTheme = void 0;
const default_1 = __importDefault(require("./default"));
exports.recycleTheme = Object.assign(Object.assign({}, default_1.default), { name: 'recycle', colors: Object.assign(Object.assign({}, default_1.default.colors), { css: Object.assign(Object.assign({}, default_1.default.colors.css), { primary: 'invert(37%) sepia(94%) saturate(992%) hue-rotate(82deg) brightness(94%) contrast(105%)' }), main: {
            base: '#0BA100',
            tap: '#23AA19',
            hover: '#5FC059',
            focus: 'rgba(59, 179, 51, 0.4)',
        }, discount: {
            base: '#0BA100',
            savings: '#0BA100',
            premium: '#0BA100',
        } }) });
exports.default = exports.recycleTheme;
